import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Checkbox, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import stcLogo from '../assets/stc-logo-300x316.png';

const { Title, Text } = Typography;

const Login = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.title = "Agente | Login | Save the Children en Perú";
    }, []);

    const expired = searchParams.get('expired');

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const success = await login(values.username, values.password);
            if (success) {
                message.success('¡Bienvenido de nuevo!');
                navigate('/dashboard');
            } else {
                message.error('Credenciales incorrectas');
            }
        } catch (err) {
            message.error(err.response?.data?.data?.message || 'Error de conexión');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: '#0a0a0a'
        }}>
            <Card style={{
                width: 400,
                boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                borderRadius: 12,
                border: 'none'
            }}>
                <div style={{ textAlign: 'center', marginBottom: 30 }}>
                    <img 
                        src={stcLogo} 
                        alt="Save The Children" 
                        style={{ width: 96, marginBottom: 20 }} 
                    />
                    <Title level={3} style={{ margin: 0, color: '#333' }}>Portal Agente</Title>
                    <Text type="secondary">Inicia sesión en tu cuenta</Text>
                </div>

                {expired && (
                    <Alert
                        message="Sesión Expirada"
                        description="Tu sesión ha finalizado por inactividad."
                        type="warning"
                        showIcon
                        style={{ marginBottom: 16 }}
                    />
                )}

                <Form
                    name="login_form"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    size="large"
                >
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: '¡Por favor ingresa tu usuario!' }]}
                    >
                        <Input prefix={<UserOutlined />} placeholder="Usuario" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: '¡Por favor ingresa tu contraseña!' }]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Contraseña" />
                    </Form.Item>
                    <Form.Item>
                        <Form.Item name="remember" valuePropName="checked" noStyle>
                            <Checkbox>Recuérdame</Checkbox>
                        </Form.Item>
                    </Form.Item>

                    <Form.Item>
                        <Button 
                            type="primary" 
                            htmlType="submit" 
                            block 
                            loading={loading} 
                            style={{ background: '#DA291C', borderColor: '#DA291C' }}
                        >
                            Iniciar Sesión
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default Login;
